import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { PaymentSlipService } from '../../services/payment-slip.service';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';

@Component({
  selector: 'app-payment-validate-modal',
  templateUrl: './payment-validate-modal.component.html',
  styleUrls: ['./payment-validate-modal.component.scss'],
  providers: [DialogService],
})
export class PaymentValidateModalComponent {
  @Input() visible: boolean = false;
  @Input() dataToView: any | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() updateStateComplete = new EventEmitter<void>();

  showButtons: boolean = true;
  showConfirmation: boolean = true;
  showTextarea: boolean = true;
  primaryButtonLabel: string = 'PENDIENTE DE FIRMA';
  userData: any = null;
  isRejected: boolean = false;

  currentFile: File | null = null;
  selectedFileName: string | null = null;
  @ViewChild('pdfUploader') pdfUploader: any;

  viewDocument: string = '';

  steps = [
    { label: 'Enviado', key: 1 },
    { label: 'Pendiente', key: 2 },
    { label: 'Aprobado', key: 3 },
    { label: '', key: 4 },
  ];

  getStepLabel(index: number, status: string): string {
    if (status === 'rechazado' && index === 1) {
      // Estado 2 (Enviado) cuando es rechazado
      return 'Rechazado';
    }
    if (status === 'aprobado' && index === 3) {
      return this.steps[index].label;
    }
    return this.steps[index].label;
  }

  get visibleSteps() {
    if (this.status === 'aprobado') {
      return this.steps.slice(0, 4);
    }
    if (this.status === 'rechazado') {
      return this.steps.slice(0, 4);
    }
    return this.steps;
  }

  currentStep = 1;
  status: 'pendiente' | 'aprobado' | 'no renovado' | 'rechazado' = 'pendiente';

  statePayment = {
    statePaymentId: 1,
    statePaymentName: 'En evaluación',
  };

  isLoading: boolean = false;
  date: Date = new Date();
  collaborator: string = '';
  amount: string = '';
  currencyId: number = 0;

  hasInteracted: { [key: string]: boolean } = {
    currentFile: false,
    stateContract: false,
    selectedFileName: false,
  };

  constructor(
    private paymentSlipService: PaymentSlipService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }
  }

  ngOnChanges(): void {
    if (this.visible && this.dataToView) {
      this.isLoading = true;

      console.log('this.dataToView', this.dataToView);

      const paymentSlipId = this.dataToView.paymentSlipId;

      this.collaborator = this.dataToView.employeeName;
      this.date = this.dataToView.issueDate;
      this.amount = this.dataToView.paymentSlipAmount;
      this.currencyId = this.dataToView.currencyId;

      this.updateState(this.dataToView.stateLastPaymentSlipId);

      this.selectedFileName = this.dataToView.paymentSlipUrl
        ? this.extractFileName(this.dataToView.paymentSlipUrl)
        : null;

      this.viewDocument = this.dataToView.paymentSlipUrl;

      this.isLoading = false;

      //   this.paymentSlipService.getPaymentSlipById(paymentSlipId).subscribe({
      //     next: (payment) => {
      //         this.statePayment = {
      //             statePaymentId: payment.stateContractId,
      //             statePaymentName: payment.stateContractName,
      //         };
      //         this.updateState(payment.stateContractId);
      //         this.collaborator = this.dataToView?.employeeName;
      //         this.dateStart = payment.startDateContract;
      //         this.dateEnd = payment.endDate;

      //         this.selectedFileName = payment.paymentSlipUrl
      //           ? this.extractFileName(payment.paymentSlipUrl)
      //           : null;

      //         this.viewDocument = payment?.paymentSlipUrl;

      //         this.isLoading = false;
      this.cdr.detectChanges();
      //       },
      //       error: (err) => {
      //         this.isLoading = false;
      //         console.error('Error al cargar los datos del empleado:', err);
      //       },
      //   });
    }
  }

  updateState(stateId: number): void {
    switch (stateId) {
      case 1: // Pendiente de envío
        this.currentStep = 1;
        this.status = 'pendiente';
        this.statePayment = {
          statePaymentId: 1,
          statePaymentName: 'Pendiente de envío',
        };
        this.primaryButtonLabel = 'GENERAR PDF Y ENVIAR';
        this.showButtons = true;
        this.showConfirmation = false;
        this.showTextarea = false;
        break;

      case 2: // Enviado
        this.currentStep = 2;
        this.status = 'pendiente';
        this.statePayment = {
          statePaymentId: 2,
          statePaymentName: 'Enviado - Pendiente de firma',
        };
        this.primaryButtonLabel = 'ESPERANDO FIRMA DEL COLABORADOR';
        this.showButtons = false;
        this.showConfirmation = false;
        this.showTextarea = false;
        break;

      case 3: // Pendiente de Validación
        this.currentStep = 3;
        this.status = 'pendiente';
        this.statePayment = {
          statePaymentId: 3,
          statePaymentName: 'Pendiente de validación',
        };
        this.primaryButtonLabel = 'APROBAR';
        this.showButtons = true;
        this.showConfirmation = true;
        this.showTextarea = true; // Para comentarios de rechazo
        break;

      case 4: // Firmado (aprobado)
        this.currentStep = 4;
        this.status = 'aprobado';
        this.statePayment = {
          statePaymentId: 4,
          statePaymentName: 'Firmado y validado',
        };
        this.showButtons = false;
        this.showConfirmation = false;
        this.showTextarea = false;
        break;

      default:
        console.warn('Estado no manejado:', stateId);
    }
  }

  validateForm(): boolean {
    if (this.statePayment.statePaymentId === 1) {
      return false;
    } else {
      return !this.selectedFileName;
    }
  }

  onButtonClick() {
    this.closeDialog();
  }

  onPrimaryButtonClick(): void {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    let stateId: number;
    let title: string;
    const shouldGeneratePdf = this.statePayment.statePaymentId === 1; // Flag para saber si debemos generar PDF

    switch (this.statePayment.statePaymentId) {
      case 1:
        stateId = 2;
        title = '¡Documento enviado!';
        this.isRejected = false;
        break;
      case 2: // Enviado -> [Este cambio lo hace el colaborador al subir firma]
        console.warn('Acción no permitida desde este estado');
        return;
      case 3: // Pendiente de validación -> Firmado (Aprobado)
        stateId = 4;
        title = '¡Documento aprobado!';
        this.isRejected = false;
        break;
      default:
        console.warn('Estado no manejado:', this.statePayment.statePaymentId);
        return;
    }

    const request = {
      statePaymentSlipId: stateId,
      userId: this.userData.employeeId,
      isRejected: this.isRejected,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    appendIfDefined('statePaymentSlipId', request.statePaymentSlipId);
    appendIfDefined('userId', request.userId);
    appendIfDefined('isRejected', request.isRejected);

    if (this.currentFile) {
      appendIfDefined('file', this.currentFile);
    }

    this.paymentSlipService
      .updateStatePaymentSlip(this.dataToView.paymentSlipId, formData)
      .subscribe({
        next: (response) => {
          // Si necesitamos generar PDF y la actualización fue exitosa
          if (shouldGeneratePdf) {
            this.paymentSlipService.getGeneratePDF(this.dataToView.paymentSlipId, this.userData.employeeId).subscribe({
              next: (pdfResponse) => {
                loadingRef.close();
                this.closeDialog();
                const successMessage = 'Enviado exitosamente';
                const ref = this.dialogService.open(ModalSuccessComponent, {
                  header: '',
                  data: {
                    text: successMessage,
                    title: title,
                    icon: 'pi pi-check-circle',
                    showButton: true,
                    buttonText: 'Entendido',
                  },
                });
                this.updateStateComplete.emit();
              },
              error: (pdfError) => {
                loadingRef.close();
                console.error('Error al generar PDF:', pdfError);
                // Mostrar mensaje de éxito de todas formas, pero loguear el error del PDF
                const ref = this.dialogService.open(ModalSuccessComponent, {
                  header: '',
                  data: {
                    text: 'Documento enviado, pero hubo un problema al generar el PDF',
                    title: title,
                    icon: 'pi pi-check-circle',
                    showButton: true,
                    buttonText: 'Entendido',
                  },
                });
                this.updateStateComplete.emit();
              }
            });
          } else {
            // Flujo normal cuando no necesitamos generar PDF
            loadingRef.close();
            this.closeDialog();
            const successMessage = 'Enviado exitosamente';
            const ref = this.dialogService.open(ModalSuccessComponent, {
              header: '',
              data: {
                text: successMessage,
                title: title,
                icon: 'pi pi-check-circle',
                showButton: true,
                buttonText: 'Entendido',
              },
            });
            this.updateStateComplete.emit();
          }
        },
        error: (err) => {
          loadingRef.close();
          const ref = this.dialogService.open(ModalRejectComponent, {
            header: '',
            data: {
              text:
                err.error?.error ||
                'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
              title: '¡Lo sentimos!',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          console.error('Error al actualizar el estado:', err);
        },
      });
  }

  onRejectClick(): void {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    const stateId = 2; // mandar a enviado otra vez
    const request = {
        statePaymentSlipId: stateId,
        userId: this.userData.employeeId,
      isRejected: true,
    };

    const formData = new FormData();
    const appendIfDefined = (key: string, value: any) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      };

    appendIfDefined('statePaymentSlipId', request.statePaymentSlipId);
    appendIfDefined('userId', request.userId);
    appendIfDefined('isRejected', request.isRejected);

    if (this.currentFile) {
        appendIfDefined('file', this.currentFile);
    }

    this.paymentSlipService
      .updateStatePaymentSlip(this.dataToView.paymentSlipId, formData)
      .subscribe({
        next: (response) => {
            loadingRef.close();
            this.closeDialog();
            const successMessage = 'Rechzado exitosamente';
            const ref = this.dialogService.open(ModalSuccessComponent, {
              header: '',
              data: {
                text: successMessage,
                title: '¡Rechazado!',
                icon: 'pi pi-check-circle',
                showButton: true,
                buttonText: 'Entendido',
              },
            });
            this.updateStateComplete.emit();
        },
        error: (err) => {
            loadingRef.close();
            const ref = this.dialogService.open(ModalRejectComponent, {
              header: '',
              data: {
                text:
                  err.error?.error ||
                  'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
                title: '¡Lo sentimos!',
                showButton: true,
                buttonText: 'Entendido',
              },
            });
            console.error('Error al actualizar el estado:', err);
          },
      });

  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    event.dataTransfer!.dropEffect = 'copy';
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      const droppedFile = event.dataTransfer.files[0];

      if (this.isValidFile(droppedFile)) {
        this.currentFile = droppedFile;
        this.selectedFileName = droppedFile.name;
      } else {
        this.currentFile = null;
        this.selectedFileName = null;

        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo no es válido. Solo se permiten archivos PDF, DOC o DOCX de hasta 10 MB.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
      }
    }
  }

  isValidFile(file: File): boolean {
    const allowedExtensions = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];
    const maxSize = 10 * 1024 * 1024;

    if (!allowedExtensions.includes(file.type)) {
      console.log('Tipo de archivo no permitido:', file.type);
      return false;
    }

    if (file.size > maxSize) {
      console.log('Archivo demasiado grande:', file.size);
      return false;
    }

    return true;
  }

  openFileUpload(type: string) {
    if (type === 'pdf' && this.pdfUploader) {
      this.pdfUploader.choose();
    } else {
      console.error('El fileUploader no está disponible.');
    }
  }

  onChangeFile(event: any) {
    const selectedFile = event.files[0];
    if (selectedFile) {
      const maxSize = 10 * 1024 * 1024;
      const allowedTypes = ['application/pdf'];

      if (!allowedTypes.includes(selectedFile.type)) {
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo no es válido. Solo se permiten archivos PDF.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.currentFile = null;
        this.selectedFileName = null;
        this.hasInteracted['currentFile'] = false;
        this.validateForm();
        return;
      }

      if (selectedFile.size > maxSize) {
        const ref = this.dialogService.open(ModalRejectComponent, {
          header: '',
          data: {
            text: 'El archivo es demasiado grande. El tamaño máximo permitido es de 10 MB.',
            title: '¡Upss!',
            showButton: true,
            buttonText: 'Entendido',
          },
        });
        this.currentFile = null;
        this.selectedFileName = null;
        this.hasInteracted['currentFile'] = false;
        this.validateForm();
        return;
      }

      this.currentFile = selectedFile;
      this.selectedFileName = selectedFile.name;
      this.hasInteracted['currentFile'] = false;
      this.validateForm();
    }
    this.validateForm();
  }

  downloadFile() {
    if (this.viewDocument) {
      const link = document.createElement('a');
      link.href = this.viewDocument;
      window.open(link.href, '_blank');
      link.download = this.selectedFileName || 'documento.pdf';
    }
  }

  extractFileName(fileUrl: string): string {
    const lastDashIndex = fileUrl.lastIndexOf('-', fileUrl.lastIndexOf('.'));
    const fileName = fileUrl.substring(lastDashIndex + 1);
    return fileName;
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
